import { FC, PropsWithChildren } from 'react'
import styles from './index.module.sass'

interface Props {
  hasToasts: boolean
}

const ToastContainer: FC<PropsWithChildren<Props>> = ({ hasToasts = false, ...props }) => {
  return <div
    className={styles.toastContainer}
    style={{ pointerEvents: hasToasts ? null : 'none' }}
    {...props}
  />
}

export default ToastContainer
